<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Hobbies & Interest</h4>
          </div>
          <div class="col-lg-6 col-sm-6 text-right my-auto">
            <a class="add-btn cursor-pointer" @click="$router.push('/add-hobby')">Add</a>
          </div>
        </div>

        <div class="page-content">
          <div class="card-body py-0 px-0">
            <!-- Search -->
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i class="fa fa-search" style="position: absolute; margin: 10px"></i>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                    @keyup.enter="getList(0)"
                  />
                </div>
                <a class="search-btn btn-style cursor-pointer ml-3" @click="getList(0)">Search</a>
                <a class="search-btn btn-style cursor-pointer" @click="resetFilter">Reset</a>
              </div>
            </div>

            <!-- Table -->
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th class="sorting" id="name-col" @click="sorting('name', 'name-col')">Hobby Name</th>
                        <th class="sorting" id="id-status" @click="sorting('status', 'id-status')">Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-show="!loader">
                      <tr v-for="(data, index) in list" :key="index">
                        <td>{{ ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage + index + 1 }}</td>
                        <td>{{ data.name }}</td>
                        <td>
                          <a v-if="data.status === 'ACTIVE'" class="fill-btn btn-style">ACTIVE</a>
                          <a v-else class="reject-btn btn-style">INACTIVE</a>
                        </td>
                        <td>
                          <a class="edit-btn btn-style cursor-pointer" @click="$router.push('/edit-hobby/' + data.id)">
                            Edit
                          </a>
                          <a class="delete-btn btn-style cursor-pointer" @click="showDeletePopup(data)">Delete</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-right">
                    <Pagination @page-change="pageChange" @items-per-page-change="itemsPerPageChange" ref="listPagination" />
                  </div>
                </div>

                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DeleteModal @remove="deleteRecord($event)" @get-list="getList(0)" ref="deleteItem" />
  </div>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";

export default {
  name: "HobbyManager",
  components: { ErrorComponent, DeleteModal, Pagination },
  data() {
    return {
      loader: true,
      searchObj: {},
      offset: -1,
      list: [],
      sortBy: "",
      orderBy: "ASC",
    };
  },
  mounted() {
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) this.searchObj.order_by = orderBy;
      if (sortBy) this.searchObj.sort_by = sortBy;

      this.$api
        .getAPI({ _action: "/hobbies/list", _body: this.searchObj })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0 && this.$refs.listPagination)
            this.$refs.listPagination.setTotalCount(res.count || 0);
          this.$refs.errorComponent.setData(res, "No hobbies & interest available");
          this.$refs.errorComponent.updateListLoader(false);
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.setData(0, undefined, "");
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.orderBy = "";
      this.sortBy = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal("Delete Hobby", "Are you sure you want to delete " + data.name, data);
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/hobbies/delete/" + detail.id);
    },
  },
};
</script>
